$(function () {
    $(".capabilities-block").each(function (e) {
        var i = $(this),
            r = i.data("block-index"),
            n = i.find(".capabilities-media");
            var s = n.find("li"),
            a = s.length;
            setInterval(function () {
                a > 1 &&
                s.each(function () {
                    var e = $(this),
                        i = parseInt(e.attr("data-index")),
                        r = 1 === i,
                        n = r ? a : i - 1;
                    r
                        ?
                        (e.addClass("to-the-back"),
                            setTimeout(function () {
                                e.attr("data-index", n).removeClass("to-the-back");
                            }, 800)) :
                        e.attr("data-index", n);
                });
        }, 5e3 + 1e3 * e);
    })
})